import {
  WidgetConfigurationValues,
  WidgetGridPosition,
} from "cortex/ui/src/ui/dashboard";

import { DashboardLayout, DashboardWidgetType } from "./dashboardLayout";

export interface WidgetConfigurationTarget {
  id?: string;
  layout?: DashboardLayout;
  position?: WidgetGridPosition;
  type: DashboardWidgetType;
}

export function getConfigurationString(
  config: Readonly<Record<string, unknown>> | undefined,
  key: string,
) {
  const value = config?.[key];
  return typeof value === "string" ? value : "";
}

export function getWidgetConfigurationDetail(
  type: DashboardWidgetType,
  config: Readonly<Record<string, unknown>> | undefined,
) {
  if (type === "quick-links") {
    const links = Array.isArray(config?.links) ? config.links : [];
    return links
      .map((link) => {
        if (typeof link !== "object" || link === null) {
          return "";
        }
        const value = link as { label?: unknown; url?: unknown };
        return `${String(value.label ?? "")} | ${String(value.url ?? "")}`;
      })
      .filter(Boolean)
      .join("\n");
  }

  return getConfigurationString(
    config,
    type === "section-heading" ? "description" : "text",
  );
}

export function getWidgetConfigurationDetailLabel(type: DashboardWidgetType) {
  if (type === "section-heading") {
    return "Description";
  }
  if (type === "quick-links") {
    return "Links (Label | URL, one per line)";
  }
  return "Text";
}

export function getWidgetConfiguration(
  type: DashboardWidgetType,
  { detail, title }: WidgetConfigurationValues,
): Readonly<Record<string, unknown>> {
  if (type === "quick-links") {
    const links = detail
      .split("\n")
      .map((line) => line.split("|", 2).map((part) => part.trim()))
      .filter(([label, url]) => label && url)
      .map(([label, url]) => ({ label, url }));
    return { links, title };
  }

  if (type === "section-heading") {
    return { description: detail, title };
  }

  return { text: detail, title };
}
